require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./effective-practices-in-community-supervision.json") })
        }
      }, "path---effective-practices-in-community-supervision");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---effective-practices-in-community-supervision!./.cache/json/effective-practices-in-community-supervision.json
// module id = 889
// module chunks = 231608221292675